// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Côte d’Ivoire */
const CI = /^(?:0[157]\d{8})$/;

export default CI;
